import { ImageResponseData } from 'pages/customer/detail/imageList/type';
import { ICustomerDetail } from 'pages/customer/detail/customerDetailsT1/type';
import reducer from './reducer';
import * as ImageComparationActions from './actions';

export interface ImageComparationType {
  detailSelectImage: ImageResponseData[];
  customerDetail:ICustomerDetail | null,
  drawerState:boolean,
  previosDrawerState:boolean |null
}

export {
  ImageComparationActions,
};

export default reducer;
